import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { parseProductPrice } from '../../models/billing-product.type';
import { isBillDueDate, todayDateInputValue } from '../../models/patient-bill.type';
import { PatientPaymentService } from '../../services/database/patient-payment.service';

export interface PaymentDialogData {
  patientId: string;
  patientName: string;
}

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrl: './payment-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule],
})
export class PaymentDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PaymentDialogComponent, string | undefined>);
  readonly data = inject<PaymentDialogData>(MAT_DIALOG_DATA);
  private payments = inject(PatientPaymentService);

  readonly amount = signal('');
  readonly paidOn = signal(todayDateInputValue());
  readonly saving = signal(false);
  readonly error = signal('');
  readonly registeredBy = signal(this.registrarLabel());

  private registrarLabel(): string {
    try {
      return this.payments.registrarName();
    } catch {
      return '';
    }
  }

  async save(): Promise<void> {
    const amount = parseProductPrice(this.amount());
    if (amount == null || amount <= 0) {
      this.error.set('El monto no es válido.');
      return;
    }
    if (!isBillDueDate(this.paidOn())) {
      this.error.set('La fecha no es válida.');
      return;
    }
    this.saving.set(true);
    this.error.set('');
    try {
      const id = await this.payments.createPayment({
        patientId: this.data.patientId,
        amount,
        paidOn: this.paidOn(),
      });
      this.dialogRef.close(id);
    } catch (err) {
      console.error('[PaymentDialog] save failed', err);
      this.error.set(err instanceof Error ? err.message : 'No se pudo registrar el pago.');
      this.saving.set(false);
    }
  }
}
